import { useRef } from 'react'
import debounce from '@/utils/debounce/debounce'
import { CRM_REALTIME_CHAT_REFETCH_DEBOUNCE_MS } from '@pages/Admin/CRM/utils/crmRealtimeWebSocket'
import { useIntegrationChatDock } from './integrationChatDockHooks'
import { fetchIntegrationChatGlobalUnread } from './integrationChatGlobalUnread'

/** Тихий GET crm-integration-chat/unread-count для глобальных бейджей. */
export function useIntegrationChatDockGlobalUnreadRefetch() {
  const { applyGlobalUnread } = useIntegrationChatDock()

  const applyGlobalUnreadRef = useRef(applyGlobalUnread)
  applyGlobalUnreadRef.current = applyGlobalUnread

  const scheduleGlobalUnreadRefetchRef = useRef(
    debounce(() => {
      void (async () => {
        const snapshot = await fetchIntegrationChatGlobalUnread()
        if (snapshot != null) {
          applyGlobalUnreadRef.current(snapshot)
        }
      })()
    }, CRM_REALTIME_CHAT_REFETCH_DEBOUNCE_MS),
  )

  return scheduleGlobalUnreadRefetchRef
}
